var _path, _path2, _path3, _path4, _g, _path5, _path6, _g2, _path7, _g3, _path8, _g4, _path9, _path10, _g5, _path11, _g6, _path12, _g7, _path13, _g8, _path14, _path15, _g9, _path16, _path17;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDecoration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 193,
    height: 420,
    viewBox: "0 0 193 420",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3528 0H0V81.5911H21.3528V0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M106.764 0H85.4112V81.5911H106.764V0Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0585 0H42.7057V81.5911H64.0585V0Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_220_1283",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 81,
    width: 40,
    height: 86
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1998 81.7854H7.93166V166.485H46.1998V81.7854Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_220_1283)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.7057 84.5054H21.3529V166.096H42.7057V84.5054Z",
    fill: "white"
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M128.117 84.5051H106.764V166.096H128.117V84.5051Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_220_1283",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 136,
    y: 81,
    width: 39,
    height: 86
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M174.317 81.7854H136.048V166.485H174.317V81.7854Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_220_1283)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.822 84.5054H149.47V166.096H170.822V84.5054Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_220_1283",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 50,
    y: 81,
    width: 39,
    height: 86
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9053 81.7854H50.6372V166.485H88.9053V81.7854Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_220_1283)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.4112 84.5054H64.0584V166.096H85.4112V84.5054Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_220_1283",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 71,
    y: 166,
    width: 40,
    height: 85
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M110.258 166.291H71.99V250.99H110.258V166.291Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_220_1283)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.764 169.01H85.4112V250.601H106.764V169.01Z",
    fill: "white"
  })))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0585 169.01H42.7057V250.601H64.0585V169.01Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_220_1283",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 114,
    y: 166,
    width: 39,
    height: 85
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M152.964 166.184H114.696V250.883H152.964V166.184Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_220_1283)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.47 168.903H128.117V250.494H149.47V168.903Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_220_1283",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 250,
    width: 40,
    height: 86
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1998 250.796H7.93166V335.495H46.1998V250.796Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_220_1283)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.7057 253.515H21.3529V335.107H42.7057V253.515Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_220_1283",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 50,
    y: 250,
    width: 39,
    height: 86
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9053 250.796H50.6372V335.495H88.9053V250.796Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_220_1283)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.4112 253.515H64.0584V335.107H85.4112V253.515Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_220_1283",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 93,
    y: 250,
    width: 39,
    height: 86
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M131.611 250.796H93.3429V335.495H131.611V250.796Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_220_1283)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.117 253.515H106.764V335.107H128.117V253.515Z",
    fill: "white"
  })))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0585 338.021H42.7057V419.612H64.0585V338.021Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask8_220_1283",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 71,
    y: 335,
    width: 40,
    height: 86
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M110.258 335.301H71.99V420H110.258V335.301Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_220_1283)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.764 338.02H85.4112V419.611H106.764V338.02Z",
    fill: "white"
  })))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M149.645 0.0490723H128.293V81.6402H149.645V0.0490723Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M192.102 0.0490723H170.749V81.6402H192.102V0.0490723Z",
    fill: "white",
    fillOpacity: 0.8
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecoration);
export default __webpack_public_path__ + "static/media/decoration.dde40fe2c842d81e37c17e4b507dba98.svg";
export { ForwardRef as ReactComponent };